// Inline notice for a PDF tool that was handed a password-protected file the person chose not to unlock.
export const UNLOCK_PDF_PATH = "/tool/unlock-pdf";

/** `action` completes "so it can't be ...", e.g. "protected with a new password". */
export function protectedPdfNotice(fileName: string, action: string): string {
  return `“${fileName}” is already password-protected, so it can't be ${action} yet.`;
}
